// extracted by mini-css-extract-plugin
module.exports = {"heading":"_2oKsI2b","isNew":"x6kxffp","icon":"_2xsn3OE"};
    if(module.hot) {
      // 1545369459481
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  